<template>
  <div class="box" :style="'top:' + boxPosition + '%'">
    <div class="top-area">
      <div class="top-image-area">
        <img :src="aboutTitle" />
      </div>
    </div>

    <div class="about-us-middle-area">
      <div class="about-us-text">
        <div class="about-us-title">中国生活を全面支援する総合アプリ</div>
        <div class="about-us-demo">
          操作画面は完全・日本語環境。ネットショッピング、携帯電話料金のチャージ、音声・文字翻訳、為替計算、イエローページ等、あらゆる生活＆ビジネスシーンで役立つ機能を盛りだくさん搭載しています。
        </div>
      </div>
      <div class="about-us-mid-imag">
        <img :src="aboutImg" alt="" />
      </div>
    </div>

    <div class="bottom-area">
      <div class="bottom-bgimg">
        <img :src="aboutBg" alt="" />
      </div>
      <div class="bottom-text">多種の決済方法をフォロー</div>
      <div class="bottom-img">
        <img :src="aboutbotimg" alt="" />
      </div>
      <div class="link-us-box">
        <div class="link-us-fun">
          <div class="link-us-title">Message</div>
          <div class="link-us-rtop">
            <div class="link-us-msg">
              <img :src="aboutmsg" alt="" />
            </div>
            <div class="link-us-text">info@nanaco.com.cn</div>
          </div>
          <div class="link-us-rbottom">
            <div class="link-us-botimg1">
              <img :src="aboutbird" alt="" />
            </div>
            <div class="link-us-botimg1">
              <img :src="aboutf" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="link-us-qrcode">
        <div>
          <img :src="downloadImage.heyNanaco" />
          <img src="../../images/home/heynanaco-qrcode.png" />
        </div>
        <div>
          <img :src="downloadImage.ios" />
          <img src="../../images/home/apple-qrcode.png" />
        </div>
        <div>
          <img :src="downloadImage.android" />
          <img src="../../images/home/google-qrcode.png" />
        </div>
        <div>
          <img :src="downloadImage.service" />
          <img src="../../images/home/service-qrCode.png" />
        </div>
      </div>
      <div class="record-no" @click="linkTo()">辽ICP备17016868号-3</div>
    </div>
  </div>
</template>
<script>
import {
  downloadImage,
  aboutTitle,
  aboutImg,
  aboutBg,
  aboutbotimg,
  aboutbird,
  aboutf,
  aboutmsg,
} from "../../images/home/index";
export default {
  data() {
    return {
      boxPosition: "100",
      downloadImage,
      aboutTitle,
      aboutImg,
      aboutBg,
      aboutbotimg,
      aboutbird,
      aboutf,
      aboutmsg,
    };
  },
  methods: {
    init() {
      // this.isCanvasShow = true
      // this.$nextTick(() => {
      //   RENDERER.init(document.getElementsByClassName('canvas-area')[0])
      // })
    },
    up() {
      this.boxPosition = "-100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
    nomal() {
      this.boxPosition = "0";
      // this.init()
    },
    down() {
      this.boxPosition = "100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
    linkTo() {
      window.open("http://beian.miit.gov.cn/");
    },
    toFaceBook() {
      window.open("https://www.facebook.com/nanacokume");
    },
    toTwitter() {
      window.open("https://twitter.com/nanacokume");
    },
    mailTo() {
      location.href = "mailto:info@nanaco.com.cn";
    },
  },
};
</script>
<style scoped>
.box {
  background: #e4ebff;
  padding-top: 50px;
}
.top-area {
  /* width: 700px;
  margin: 0 auto;
  margin-top: 60px;
  display: flex; */
  width: 100%;
  height: 100%;
}

.top-image-area {
  text-align: center;
  width: 2.5rem;
  height: 2rem;
  position: absolute;
  top: 0.6rem;
  left: 50%;
  margin-left: -1.5rem;
  z-index: 99;
}
.top-image-area img {
  width: 100%;
  height: auto;
}
.about-us-middle-area {
  position: absolute;
  top: 2rem;
  left: 0.5rem;

  display: flex;
  justify-content: space-around;
  width: 100%;
}
.about-us-mid-imag {
  width: 6rem;
  margin-right: 0.1rem;
}
.about-us-mid-imag img {
  width: 100%;
  height: auto;
}
.about-us-title {
  font-weight: bold;
  font-size: 0.35rem;

  margin-top: 0.25rem;
}
.about-us-demo {
  width: 5.5rem;
  font-size: 0.18rem;
  line-height: 0.38rem;
  margin-top: 0.2rem;

  /* font-weight: 500; */
}
.bottom-area {
  position: absolute;

  bottom: 0;
  width: 100%;
  top: 50%;
  left: 0;
  right: 0;

  height: 50%;
  overflow: hidden;
  box-sizing: border-box;
  /* padding-top: 500px;
  padding-bottom: 50px; */

  z-index: 0;
}
.bottom-text {
  position: absolute;
  top: 0.5rem;
  left: 3rem;
  font-size: 0.2rem;
}
.bottom-img {
  position: absolute;
  top: 1rem;
  left: 1.5rem;
  width: 6rem;
}
.bottom-img img {
  width: 100%;
  height: auto;
}
.bottom-bgimg {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
}
.bottom-bgimg img {
  width: 100%;
  height: 100%;
}

.link-us-box {
  width: 4rem;
  height: 100%;
  display: flex;
  position: absolute;
  left: 10rem;
  top: 1.7rem;
  z-index: 9;
}
.link-us-fun {
  flex: 1;
  box-sizing: border-box;
  vertical-align: top;
}
.link-us-title {
  font-size: 0.25rem;
  font-weight: bold;
  color: #707691;
}

.link-us-rtop {
  width: 4rem;
  display: flex;
  justify-content: flex-start;
  margin-top: 0.3rem;
}
.link-us-msg {
  margin-right: 0.1rem;
  width: 0.3rem;
  height: 100%;
}
.link-us-msg img {
  width: 100%;
  height: auto;
}
.link-us-text {
  font-size: 0.18rem;
  color: white;
}
.link-us-rbottom {
  display: flex;
  justify-content: flex-start;
  width: 3rem;
  margin-top: 0.7rem;
}
.link-us-botimg1 {
  width: 0.5rem;
  height: 100%;
  margin-right: 0.3rem;
}
.link-us-botimg1 img {
  width: 100%;
  height: auto;
}
.link-us-qrcode {
  width: 5rem;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;

  position: absolute;
  top: 1.7rem;
  left: 1.5rem;
  z-index: 9;
}
.link-us-qrcode div {
  width: 1.5rem;
  margin: 0 0.05rem;
}
.link-us-qrcode div img:nth-child(1) {
  display: block;
  width: 100%;
}
.link-us-qrcode div img:nth-child(2) {
  width: 1.5rem;
  height: 1.5rem;

  margin-top: 0.2rem;
}
.record-no {
  width: 5rem;
  text-align: center;
  bottom: 0.6rem;
  position: absolute;
  height: 0.2rem;
  left: 0;
  right: 0;
  margin: auto;
  color: #707691;
  font-size: 0.1rem;
}
.link-us-box .link-us-fun:nth-child(2) .link-us-msg {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/home/modules/about-us.vue